import React from 'react';
import { connect } from 'react-redux'
import setUserRoleAction from '../../actions/setUserRoleAction'
import setRoleIdAction from '../../actions/setRoleIdAction'
import setRoleNameAction from '../../actions/setRoleNameAction'
import setUserNameAction from '../../actions/setActionUserName'
import { Redirect } from "react-router-dom";
import LogoLoginRole from '../Logo/LogoLoginRole';
import Ulylogo from '../Logo/logoUlysses';
import SvgUser from '../../iconComponents/usertextboxIcon';
import Svglock from '../../iconComponents/locktextboxIcon';
import FetchData from '../Utils/FetchData';
const $ = window.$;
var bg = require('../../images/login_bg.png')
function disableF5(e) { if ((e.which || e.keyCode) == 116) e.preventDefault(); };
function myFunction() {
    document.getElementById("myDropdown").classList.toggle("show");
}

// Close the dropdown menu if the user clicks outside of it
window.onclick = function (event) {
    if (!event.target.matches('.dropbtn')) {

        var dropdowns = document.getElementsByClassName("dropdown-content");
        var i;
        for (i = 0; i < dropdowns.length; i++) {
            var openDropdown = dropdowns[i];
            if (openDropdown.classList.contains('show')) {
                openDropdown.classList.remove('show');
            }
        }
    }
}
class Role extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            userName: this.props.location.state.userName,
            roles: [],
            data: [],
            selectValue: null,
            selectRole: ''
        };
    }

    //TM(Thanasis Mourselas):React life cycle component componentWillMount() is executed just before the React Component is about to mount on the DOM.
    componentWillMount() {

        if (this.props.defaultRoleIDState === -1) {
            FetchData('/api/RTFCW/UserRolesA/' + this.props.usedataState)
                .then((data) => {
                    this.props.idRoleSet(data.data[0].id)
                    this.props.nameRoleSet(data.data[0].name)
                    this.setState({ roles: data.data })
                    this.setState({ selectRole: data.data[0].name })
                }).catch(error => {
                    console.log(error.data);
                })
        }
    }

    //TM(Thanasis Mourselas):event to exit and return to logged in view
    handleClick = () => {
        this.props.history.push("");
    }
    openDropdown = event => {

        document.getElementById("myDropdown").classList.toggle("show");

    }
    //TM(Thanasis Mourselas):event to procceed user to  TaskView
    Proceedclick = () => {
        var rolename = this.state.roles[0].name
        if (this.state.selectValue != null) {

            this.props.idRoleSet(this.state.selectValue)
            this.props.nameRoleSet(this.state.roles.find(r => r.id == this.state.selectValue).name)
            rolename = this.state.roles.find(r => r.id == this.state.selectValue).name
        }
        //alert(this.state.userName)
        this.props.nameUserSet(this.state.userName)
        this.props.history.push('/taskview');
        //this.props.history.push({
        //    pathname: '/taskview',
        //    state: {
        //        userName1: this.state.userName,
        //    },
        //})
    }
    selectedRole = (id) => {

        var splitId = id.split(',')
        this.setState({
            selectRole: splitId[1],
            selectValue: splitId[0]
        })

    }
    //TM(Thanasis Mourselas):event to procceed user to change role from dropdown


    render() {
        //TM(Thanasis Mourselas):loop roles and render to dropdown
        if (this.props.defaultRoleIDState != -1) {

            FetchData('/api/RTFCW/UserRolesA/' + this.props.usedataState)
                .then((data) => {


                    this.props.nameRoleSet(data.data.find(r => r.id == this.props.defaultRoleIDState).name)
                }).catch(error => {
                    console.log(error.data);
                })

            this.props.idRoleSet(this.props.defaultRoleIDState)
            return <Redirect to={{ pathname: '/taskview', state: { userName: this.props.username }}} />
        }
        if (this.state.roles.length == 1) {
                return <Redirect to={{ pathname: '/taskview', state: { userName: this.props.username }}} />
        }
        let optionItems = this.state.roles.map((role, key) =>
            <li onClick={this.selectedRole.bind(this, + role.id + "," + role.name)} key={role.id} value={role.id}>{role.name}</li>
        );

        return (
            <div className="limiter">
                <div className="container-login100">
                    <div className="login100-more"></div>
                    <div className="wrap-login100 p-l-50 p-r-50 p-t-72 p-b-50">
                        <form className="login100-form validate-form">
                            <span className="login100-form-title p-b-59">
                                <LogoLoginRole />

                            </span>
                            <span className="login100-form-secondtitle p-b-59">
                                Please enter your authentication details
                            </span>
                            <div className="wrap-inputUser validate-input" data-validate="Username is required">
                                <span className="label-input100">Username</span>
                                <div className="row">
                                    <div className="icon">
                                        <SvgUser />
                                    </div>
                                    <input
                                        type="text"
                                        disabled
                                        name=""
                                        placeholder={this.state.userName} />
                                    <span className="focus-input100"></span>
                                </div>
                            </div>
                            <div className="wrap-inputPass validate-input" data-validate="Password is required">
                                <span className="label-input100">Password</span>
                                <div className="row">
                                    <div className="icon">
                                        <Svglock />
                                    </div>
                                    <input className="input100" type="text" disabled name="pass" placeholder="*************" />
                                    <span className="focus-input100"></span>
                                </div>
                            </div>

                            <div className="dropdown">
                                <ul onClick={this.openDropdown} className="dropbtn">{this.state.selectRole}</ul>
                                <div id="myDropdown" className="dropdown-content">
                                    {
                                        optionItems
                                    }


                                </div>
                            </div>

                            <div className="container-Role100-form-btn" >
                                <div className="wrap-login100-form-btn" style={{ marginLeft: '13px !Important' }}>
                                    <div className="login100-form-bgbtn"></div>
                                    <button className="Role100-form-btn"
                                        onClick={this.handleClick}>

                                        Change User
							    </button>
                                </div>
                                <div className="wrap-login100-form-btn" style={{ marginLeft: '13px !Important' }}>
                                    <div className="login100-form-bgbtn"></div>
                                    <button className="Role100-form-btn"
                                        onClick={this.Proceedclick}>
                                        Proceed
							    </button>
                                </div>
                            </div>
                            <div className="BottomDiv">
                                <p className="BottomLogoRole" style={{ marginLeft: '-30px' }}><Ulylogo /></p>
                                <p className="ulyUrl"><span>www.ulysses-systems.com</span></p>

                            </div>
                        </form>
                    </div>
                </div>
            </div>
        );
    }
}
const mapStateToProps = state => {
    return {
        usedataState: state.userData,
        defaultRoleIDState: state.currDefaultRoleIDState
    }
};

const mapDispatchToProps = dispatch => {
    return {
        userRoleSet: payload => dispatch(setUserRoleAction(payload)),
        idRoleSet: payload => dispatch(setRoleIdAction(payload)),
        nameRoleSet: payload => dispatch(setRoleNameAction(payload)),
        nameUserSet: payload => dispatch(setUserNameAction(payload))
        
    };
};
export default connect(mapStateToProps, mapDispatchToProps)(Role);


// WEBPACK FOOTER //
// ./src/components/Role/Role.js